/**
 * 封装 sessionStorage
 */
export default {
  set (key, value) {
    window.sessionStorage.setItem(key, JSON.stringify(value))
  },

  get (key) {
    let value = window.sessionStorage.getItem(key)
    try {
      value = JSON.parse(value)
    } catch (error) {}

    return value
  },

  remove (key) {
    window.sessionStorage.removeItem(key)
  },

  clear () {
    window.sessionStorage.clear()
  }
}



// WEBPACK FOOTER //
// ./src/helpers/session.js